import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query/types/react/types";
import { UTILS_API_PATH } from "src/confs/APIConfig";
import { useApiGet } from "src/shared/actions/FetchActions";
import { Language } from "src/shared/objects/Language";

export const useLanguages = (
  countryCode?: string,
  options?: UseQueryOptions<
    Language[],
    unknown,
    Language[],
    ["languages", string | undefined]
  >,
) => {
  const apiGet = useApiGet();
  return useQuery(
    ["languages", countryCode],
    async () => {
      const { data } = await apiGet<unknown[]>(
        `${UTILS_API_PATH}/languages/${countryCode || ""}`,
      );
      return data.map((languageJSON) => {
        return new Language(languageJSON);
      });
    },
    options,
  );
};
